import { render, staticRenderFns } from "./Div_planilla.vue?vue&type=template&id=752f5dd8"
import script from "./Div_planilla.vue?vue&type=script&lang=js"
export * from "./Div_planilla.vue?vue&type=script&lang=js"
import style0 from "./Div_planilla.vue?vue&type=style&index=0&id=752f5dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports